import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MsalInitService {
  private initializationPromise: Promise<void> | null = null;
  private isInitialized = false;

  constructor(
    private msalService: MsalService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  async ensureInitialized(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }

    if (this.isInitialized) {
      return Promise.resolve();
    }

    if (this.initializationPromise) {
      return this.initializationPromise;
    }

    this.initializationPromise = this.initializeMsal();
    return this.initializationPromise;
  }

  private async initializeMsal(): Promise<void> {
    try {
      await this.msalService.instance.initialize();
      this.isInitialized = true;
    } catch (error) {
      throw error;
    }
  }

  get initialized(): boolean {
    return this.isInitialized;
  }
}